<template>
  <div id="app">
    <div id="modal"/>
    <div id="add-user-modal"/>
    <div id="preview-modal"/>
    <div id="mail-modal"/>
    <div id="save-modal"/>
    <div id="camera-position-modal"/>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style src="./css/reset.scss" lang="scss"></style>
<style src="./hakotan/css/dcstyle.scss" lang="scss"></style>
<style>
html, body {
  height: 100%;
  padding-top: constant(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-left: constant(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);

  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/AppDc.vue